import { render, staticRenderFns } from "./ProprietaryPortfolio.vue?vue&type=template&id=dca1e402&scoped=true"
import script from "./ProprietaryPortfolio.vue?vue&type=script&lang=js"
export * from "./ProprietaryPortfolio.vue?vue&type=script&lang=js"
import style0 from "./ProprietaryPortfolio.vue?vue&type=style&index=0&id=dca1e402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca1e402",
  null
  
)

export default component.exports